import { render, staticRenderFns } from "./passo9.vue?vue&type=template&id=f2350ece&scoped=true&"
import script from "./passo9.vue?vue&type=script&lang=js&"
export * from "./passo9.vue?vue&type=script&lang=js&"
import style0 from "./passo9.vue?vue&type=style&index=0&id=f2350ece&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2350ece",
  null
  
)

export default component.exports